export default {
  title01: "Anlık Hava Durumu",
  title02: "24 Saat",
  title03: "10 Günlük Hava Durumunu Görüntüle",
  title04: "Hava Kalitesi İndeksi",
  title05: "Bütün Bilgileri Görüntüle",
  title06: "GÜN DOĞUMU VE GÜN BATIMI",
  title07: "AYIN DÖNGÜLERİ",
  title08: " Bir Sonraki Dolunay",
  title09: "Bir Sonraki Yeni Ay",
  title10: "GÜN",
  title11: "GECE",
  title12: "Gün Doğumu",
  title13: "Gün Batımı",
  title14: "Ay Doğumu",
  title15: "Ay Batımı",
  title16: "Kaynak",
  title17: "Başlangıç",
  title18: "Bitiş",
  title19: "Anlık Konumu Kullan",
  title20: "Şehir Ara",
  title21: "Hissedilen",
  title22: "Gölgede Hissedilen Sıcaklık",
  title23: "Şuan",
  title24: "Bugün",
  title25: "PZR",
  title26: "PZRT",
  title27: "SALI",
  title28: "ÇRŞ",
  title29: "PRŞ",
  title30: "CUMA",
  title31: "CMRT",
  title32: "Yükleniyor...",
  title33: "Şuanda",
  title34: "Saatlik",
  title35: "Günlük",
  title36: "Güneş ve Ay",
  title37: "Hava Kalitesi",
  title38: "İletişim İçin: xlf550402@gmail.com",
  title39: "Gizlilik Politikası'",
  title40: "Copyright © comfortweather.com 2020 - 2025. Her hakkı saklıdır.",
  title41: "",
  title42: "Tmax",
  title43: "Tmin",
  title44: "Kabul",
  title45:
    "ComfortWeather'ı kullandığınız için teşekkür ederiz. Yasal haklarınızı ve kişisel bilgilerinizi daha iyi koruyabilmek adına, lütfen ",
  title46: "Gizlilik Politikası'",
  title47: " nı dikkatlice okuyunuz.",
  title48: "tarafından veriler sağlanmıştır.",
  title49: "İletişim İçin: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2025. Her hakkı saklıdır.",
  title51:
    "24hweather'ı kullandığınız için teşekkür ederiz. Yasal haklarınızı ve kişisel bilgilerinizi daha iyi koruyabilmek adına, lütfen ",
};
